import { Injectable, Type } from '@angular/core';
import { GenderComponent } from './gender/gender.component';
import { BornDateComponent } from './born-date/born-date.component';
import { RegistrationStep } from 'angular-lib';
import { RegisterUserComponent } from './register-user/register-user.component';
import { LocationComponent } from './location/location.component';
import { PhotoComponent } from './photo/photo.component';

@Injectable()
export class RegistrationConstants {
    public mapping: { [id: string]: Type<RegistrationStep> } = {
        'gender': GenderComponent,
        'born-date': BornDateComponent,
        'register-user': RegisterUserComponent,
        'location': LocationComponent,
        'photo': PhotoComponent
    };

    public steps = [
        'gender',
        'born-date',
        'register-user',
        'location',
        'photo'
    ];

    public facebookFirstStep = 'location';
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/registration/registration.constants.ts